import Typography from "@mui/material/Typography";
import dynamic from "next/dynamic";

const ParseHtml = dynamic(() => import('../../../../Custom/ParseHtml'))

const ProductFAQs = (props) => {
    const { 
        faqs,
     } = props;

    return (
            <div id="faqs">
                {faqs.map((faq, idx) => {
                    return (
                        <div className="mb-2" key={idx}>
                            <Typography color="primary" component="h3" variant="h6"><strong>{faq.question}</strong></Typography>
                            <ParseHtml html={faq.answer}/>
                        </div>
                    )
                })}
            </div>
    )
}

export default ProductFAQs